import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

import queryClient from './utils/QueryClient/QueryClient';

import App from './App/App';

import './index.styl';

const container = document.getElementById('js-mapframe');
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);